import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SpinnerMessageService {
     message$ = new Subject<string>();

     constructor() {}

     reset() {
          this.message$.next(window.appLang.LOADING);
     }

     accessControlValidation() {
          this.message$.next(
               window.appLang.AUTHORIZATION_IN_PROGRESS +
                    '.' +
                    window.appLang.PLEASE_WAIT +
                    '.'
          );
     }
}
